/**
 * Iris nelle pagine di Commesse: una configurazione del componente di chat
 * condiviso, con la stessa forma di Aida (barra sul bordo, pannello che occupa
 * spazio, casella che cresce).
 *
 * *Intelligenza per Reperimento, Inventario e Spedizione* — agente delle
 * commesse, condiviso, senza referente unico.
 *
 * Gli esempi cambiano con la sezione da cui la apri: chiedere è più facile se
 * ti suggeriscono cosa.
 */
import { ChatAgente } from "@/components/agenti/ChatAgente";

const BASE_PATH = "/api/v1/m1/agente/chat";

const SUGGERIMENTI: Record<string, string[]> = {
  cruscotto: [
    "Come siamo messi?",
    "Chi tiene ferma più merce?",
    "Quanta merce è pronta e non ritirata?",
  ],
  portafoglio: [
    "Perché la 122 è ferma?",
    "Commesse di Wonderfood",
    "Quali commesse posso passare a logistica?",
  ],
  magazzino: [
    "Cosa produco per primo?",
    "Quali articoli non hanno piano?",
    "Cosa sblocca MSP55012?",
  ],
};

export function IrisDock({
  sezione,
  aperta,
  onApertaChange,
}: {
  sezione: "cruscotto" | "portafoglio" | "magazzino";
  aperta: boolean;
  onApertaChange: (v: boolean) => void;
}) {
  return (
    <ChatAgente
      aperta={aperta}
      onApertaChange={onApertaChange}
      nome="Iris"
      stato="assistente commesse"
      basePath={BASE_PATH}
      modo="inline"
      benvenuto="Ciao! Posso rispondere su commesse, magazzino e articoli. Cosa ti serve?"
      suggerimenti={SUGGERIMENTI[sezione]}
    />
  );
}
